import type { DiscoveryFilter } from "../../types/filters/common";
import { InsightsFromAIFilterField } from "../../types/filters/insightFromAI";

export const insightsFromAIFilters: DiscoveryFilter[] = [
    {
        label: "Content Types",
        field: InsightsFromAIFilterField.CONTENT_TYPES,
        isAdditional: true,
    },
    {
        label: "Brand",
        field: InsightsFromAIFilterField.BRAND,
        isAdditional: true,
    },
    {
        label: "Browse node",
        field: InsightsFromAIFilterField.BROWSE_NODE,
        isAdditional: true,
    },
];

export const getInsightsFromAIFilters = (
    isAccountAgnostic: boolean,
): DiscoveryFilter[] => {
    return isAccountAgnostic
        ? insightsFromAIFilters.filter(
              (filter) =>
                  filter.field === InsightsFromAIFilterField.CONTENT_TYPES,
          )
        : insightsFromAIFilters;
};

export const defaultInsightsFromAIFilters = insightsFromAIFilters.filter(
    (filter) =>
        [
            InsightsFromAIFilterField.CONTENT_TYPES,
            InsightsFromAIFilterField.BRAND,
            InsightsFromAIFilterField.BROWSE_NODE,
        ].includes(filter.field as InsightsFromAIFilterField),
);
